import '../styles/app.css';
import './navbar.js';
import $ from 'jquery'; // core version + navigation, pagination modules:
import Swiper from 'swiper';
// eslint-disable-next-line no-unused-vars
import {
  Navigation,
  Pagination,
  Autoplay,
} from 'swiper/modules';
import {
  Fancybox,
} from "@fancyapps/ui";
import Alpine from 'alpinejs';

// Expose Swiper globally for inline scripts (e.g. profile template)
window.Swiper = Swiper;
window.SwiperNavigation = Navigation;

window.Alpine = Alpine;
Alpine.start();

// Anti-FOUC backup: retire la classe de masquage au plus tôt si le script inline a échoué
try {
  const unhide = () => {
    const b = document && document.body;
    if (b && b.classList && b.classList.contains('is-fouc-hidden')) {
      b.classList.remove('is-fouc-hidden');
    }
  };
  if (document.readyState !== 'loading') {
    // DOM déjà prêt
    unhide();
  } else {
    document.addEventListener('DOMContentLoaded', unhide);
  }
  window.addEventListener('load', unhide);
} catch (e) {
  // no-op
}

/**
 * app.main
 */
const main = async (err) => {
  if (err) {
    // handle hmr errors
    console.error(err);
  }

  // application code
};

/**
 * Initialize
 *
 * @see https://webpack.js.org/api/hot-module-replacement
 */
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => main());
} else {
  main();
}

/* Fancybox */
Fancybox.bind("[data-fancybox]", {
  // Options personnalisées au besoin
  // https://fancyapps.com/fancybox/getting-started/
});

/* Burger menu */
$(document).ready(function () {
  /*$('.open-burger').click(function () {
    if ($('.hamburger').hasClass('is-active')) {
      $('.hamburger').removeClass('is-active').css('marginTop', '0px').css('marginRight', '0px');
      $('#menu-principal-mobile').hide();
      $('body').removeClass('overflow-hidden')
    } else {
      $('.hamburger').addClass('is-active').css('marginTop', '10px').css('marginRight', '10px');
      setTimeout(() => {
        $('#menu-principal-mobile').show();
      }, 100);
      $('body').addClass('overflow-hidden')
    }
  });*/
});

jQuery(document).ready(function ($) {
  $('a[href^="#"]').on('click', function (e) {
    var target = $(this.getAttribute('href'));

    if (target.length) {
      e.preventDefault();
      $('html, body').animate({
        scrollTop: target.offset().top,
      }, 600); // durée du scroll en ms
    }
  });

  /* Publications: AJAX filtres + load more */
  const $pubArchive = $('.js-pub-archive');
  if ($pubArchive.length) {
    const $grid = $pubArchive.find('.js-pub-grid');
    const $empty = $pubArchive.find('.js-pub-empty');
    const ajaxUrl = $pubArchive.data('ajax-url');
    const term = $pubArchive.data('term');

    const setLoading = (isLoading) => {
      $pubArchive.toggleClass('is-loading', !!isLoading);
    };

    const updateButton = (hasMore, nextPage) => {
      // Ne pas altérer le design: ne manipuler que la présence et l'attribut data-next-page
      // Classes conservées comme dans le template Blade
      let $btn = $pubArchive.find('.js-pub-load');
      if (!hasMore) {
        $btn.closest('.text-center.mt-16').remove();
        return;
      }
      if (!$btn.length) {
        // Recrée exactement la même structure/markup que le template
        $btn = $('<button/>', {
          type: 'button',
          class: 'js-pub-load button-standard-vert-fleche fleche-bas transition-all bg-vertclair',
          text: 'Voir plus',
          'aria-live': 'polite',
          'data-next-page': nextPage,
        });
        const $cta = $('<div/>', { class: 'cta text-center ' }).append($btn);
        const $wrap = $('<div/>', { class: 'text-center mt-16' }).append($cta);
        $pubArchive.append($wrap);
      } else {
        $btn.attr('data-next-page', nextPage);
      }
    };

    const render = (html, append) => {
      if (append) {
        if (!$grid.length) return;
        $grid.append(html);
      } else {
        if (!$grid.length) {
          // créer la grille si absente
          const $newGrid = $('<div/>', { class: 'js-pub-grid grid sm:grid-cols-2 lg:grid-cols-3 gap-x-[10px] gap-y-[19px]' });
          $newGrid.html(html);
          // Nettoie d'éventuels wrappers de bouton load-more précédents
          $pubArchive.find('.text-center.mt-12, .text-center.mt-16').has('.js-pub-load').remove();
          $pubArchive.find('.js-pub-empty').remove();
          $pubArchive.prepend($newGrid);
        } else {
          $grid.html(html);
        }
      }
    };

    const handleEmpty = (isEmpty) => {
      if (isEmpty) {
        if ($empty.length) {
          $empty.show();
        } else {
          $pubArchive.prepend($('<p/>', { class: 'js-pub-empty text-center', text: 'Aucune publication trouvée.' }));
        }
      } else {
        $pubArchive.find('.js-pub-empty').remove();
      }
    };

    const fetchPublications = ({ page = 1, sub = '', append = false }) => {
      if (!ajaxUrl || !term) return;
      setLoading(true);
      $.ajax({
        url: ajaxUrl,
        type: 'POST',
        dataType: 'json',
        data: {
          action: 'load_publications',
          term: term,
          sub: sub,
          page: page,
        },
      }).done((res) => {
        if (!res || !res.success) {
          return;
        }
        const { html, has_more, next_page } = res.data || {};
        const isEmpty = !html || html.trim() === '';
        handleEmpty(isEmpty);
        if (!isEmpty) {
          render(html, append);
        } else if (!append) {
          // si vide et pas d'append, vider la grille
          $grid.empty();
        }
        updateButton(!!has_more, next_page);
        // mettre à jour les data
        $pubArchive.attr('data-page', page);
        $pubArchive.attr('data-sub', sub);
      }).fail(() => {
        // noop minimal
      }).always(() => {
        setLoading(false);
      });
    };

    // Click sur "Voir plus"
    $(document).on('click', '.js-pub-load', function (e) {
      e.preventDefault();
      const $btn = $(this);
      const nextPage = parseInt($btn.attr('data-next-page') || '2', 10);
      const sub = String($pubArchive.attr('data-sub') || '');
      fetchPublications({ page: nextPage, sub, append: true });
    });

    // Clics sur filtres
    const $filters = $('.js-pub-filters');
    $filters.on('click', '.js-pub-filter', function (e) {
      e.preventDefault();
      const $link = $(this);
      const sub = String($link.data('sub') || '');

      // Gestion minimaliste de l'état: une seule classe 'active'
      $filters.find('.js-pub-filter').removeClass('active');
      $link.addClass('active');

      // Mettre à jour l'URL sans recharger
      const baseUrl = $filters.data('base-url');
      const newUrl = sub ? `${baseUrl}?sub=${encodeURIComponent(sub)}` : baseUrl;
      if (window.history && window.history.pushState) {
        window.history.pushState({ sub }, '', newUrl);
      }

      // Charger page 1 pour ce filtre
      fetchPublications({ page: 1, sub, append: false });
      // remonter au début de la grille
      const top = $grid.length ? $grid.offset().top - 150 : $pubArchive.offset().top - 100;
      $('html, body').animate({ scrollTop: top }, 300);
    });
  }

  /* Blogue: AJAX filtres (catégorie + thème, combinés en ET) + load more */
  const $blogArchive = $('.js-blog-archive');
  if ($blogArchive.length) {
    const ajaxUrl = $blogArchive.data('ajax-url');
    const $blogFilters = $('.js-blog-filters');
    const baseUrl = $blogFilters.data('base-url') || window.location.pathname;

    // Taxonomies pilotées (mêmes clés que le PHP)
    const TAXONOMIES = ['blog_categorie', 'blog_theme'];

    // État courant des filtres, initialisé depuis l'URL
    const urlParams = new URLSearchParams(window.location.search);
    const state = {};
    TAXONOMIES.forEach((tax) => {
      state[tax] = urlParams.get(tax) || '';
    });

    const setLoading = (isLoading) => {
      $blogArchive.toggleClass('is-loading', !!isLoading);
    };

    const buildUrl = () => {
      const q = new URLSearchParams();
      TAXONOMIES.forEach((tax) => {
        if (state[tax]) q.set(tax, state[tax]);
      });
      const qs = q.toString();
      return qs ? `${baseUrl}?${qs}` : baseUrl;
    };

    // Met à jour l'apparence des pills selon l'état (une seule active par groupe)
    const syncActive = () => {
      $('.js-blog-filter').each(function () {
        const $a = $(this);
        const tax = String($a.data('tax'));
        const term = String($a.data('term') || '');
        const isActive = (state[tax] || '') === term;
        $a.toggleClass('bg-sombre text-clair100', isActive);
        $a.toggleClass(
          'bg-transparent text-sombre hover:bg-sombre hover:text-clair100',
          !isActive,
        );
        if (isActive) {
          $a.attr('aria-current', 'page');
        } else {
          $a.removeAttr('aria-current');
        }
      });
    };

    const updateButton = (hasMore, nextPage) => {
      let $btn = $blogArchive.find('.js-blog-load');
      if (!hasMore) {
        $btn.remove();
        return;
      }
      if (!$btn.length) {
        $btn = $('<button/>', {
          type: 'button',
          class:
            'js-blog-load border-2 font-bold border-sombre text-sombre px-6 py-2 rounded text-[15px] rounded-[50px] transition-all duration-300 hover:bg-sombre hover:text-clair100',
          text: 'Voir plus d’articles',
          'aria-live': 'polite',
          'data-next-page': nextPage,
        });
        let $wrap = $blogArchive.find('.text-center.mt-12');
        if (!$wrap.length) {
          $wrap = $('<div/>', { class: 'text-center mt-12' }).appendTo($blogArchive);
        }
        $wrap.empty().append($btn);
      } else {
        $btn.attr('data-next-page', nextPage);
      }
    };

    const fetchBlogPosts = ({ page = 1, append = false }) => {
      if (!ajaxUrl) return;
      setLoading(true);
      $.ajax({
        url: ajaxUrl,
        type: 'POST',
        dataType: 'json',
        data: {
          action: 'load_blog_posts',
          page,
          blog_categorie: state.blog_categorie,
          blog_theme: state.blog_theme,
        },
      })
        .done((res) => {
          if (!res || !res.success) return;
          const { html, has_more, next_page } = res.data || {};
          const isEmpty = !html || html.trim() === '';

          let $grid = $blogArchive.find('.js-blog-grid');

          if (append) {
            if (!isEmpty && $grid.length) $grid.append(html);
          } else if (isEmpty) {
            $grid.remove();
            if (!$blogArchive.find('.js-blog-empty').length) {
              $blogArchive.prepend(
                $('<p/>', { class: 'js-blog-empty text-center', text: 'Aucun article trouvé.' }),
              );
            }
          } else {
            $blogArchive.find('.js-blog-empty').remove();
            if (!$grid.length) {
              $grid = $('<div/>', {
                class: 'js-blog-grid grid sm:grid-cols-2 lg:grid-cols-3 gap-[63px]',
              });
              $blogArchive.prepend($grid);
            }
            $grid.html(html);
          }

          updateButton(!!has_more, next_page);
          $blogArchive.attr('data-page', page);
        })
        .always(() => setLoading(false));
    };

    // Clic sur un filtre (intercepte le lien de repli)
    $blogFilters.on('click', '.js-blog-filter', function (e) {
      e.preventDefault();
      const $a = $(this);
      const tax = String($a.data('tax'));
      const term = String($a.data('term') || '');
      if (!(tax in state)) return;

      // Bascule : re-cliquer sur un filtre actif le désélectionne.
      state[tax] = state[tax] === term ? '' : term;
      syncActive();

      const newUrl = buildUrl();
      if (window.history && window.history.pushState) {
        window.history.pushState({ ...state }, '', newUrl);
      }

      fetchBlogPosts({ page: 1, append: false });
    });

    // Voir plus
    $(document).on('click', '.js-blog-load', function (e) {
      e.preventDefault();
      const nextPage = parseInt($(this).attr('data-next-page') || '2', 10);
      fetchBlogPosts({ page: nextPage, append: true });
    });
  }

  /* Événements: AJAX filtre catégorie + "afficher plus" (révèle les items masqués) */
  const $evtArchive = $('.js-evt-archive');
  if ($evtArchive.length) {
    const ajaxUrl = $evtArchive.data('ajax-url');
    const $evtFilters = $('.js-evt-filters');
    const baseUrl = $evtFilters.data('base-url') || window.location.pathname;

    // État courant (une seule taxonomie : categorie_evenement), initialisé depuis l'URL
    const urlParams = new URLSearchParams(window.location.search);
    const state = { categorie_evenement: urlParams.get('categorie_evenement') || '' };

    const setLoading = (isLoading) => {
      $evtArchive.toggleClass('is-loading', !!isLoading);
    };

    const buildUrl = () => {
      const q = new URLSearchParams();
      if (state.categorie_evenement) q.set('categorie_evenement', state.categorie_evenement);
      const qs = q.toString();
      return qs ? `${baseUrl}?${qs}` : baseUrl;
    };

    // Met à jour l'apparence des pills selon l'état (une seule active)
    const syncActive = () => {
      $('.js-evt-filter').each(function () {
        const $a = $(this);
        const term = String($a.data('term') || '');
        const isActive = state.categorie_evenement === term;
        $a.toggleClass('bg-vertfonce text-white', isActive);
        $a.toggleClass('bg-white text-sombre hover:bg-clair100', !isActive);
        if (isActive) {
          $a.attr('aria-current', 'page');
        } else {
          $a.removeAttr('aria-current');
        }
      });
    };

    const fetchEvenements = () => {
      if (!ajaxUrl) return;
      setLoading(true);
      $.ajax({
        url: ajaxUrl,
        type: 'POST',
        dataType: 'json',
        data: {
          action: 'load_evenements',
          categorie_evenement: state.categorie_evenement,
        },
      })
        .done((res) => {
          if (!res || !res.success) return;
          const { html, has_more } = res.data || {};
          const isEmpty = !html || html.trim() === '';

          let $list = $evtArchive.find('.js-evt-list');

          if (isEmpty) {
            $list.remove();
            if (!$evtArchive.find('.js-evt-empty').length) {
              $evtArchive.prepend(
                $('<p/>', { class: 'js-evt-empty text-center', text: 'Aucun événement trouvé.' }),
              );
            }
          } else {
            $evtArchive.find('.js-evt-empty').remove();
            if (!$list.length) {
              $list = $('<ol/>', { class: 'js-evt-list flex flex-col' }).attr(
                'style',
                '--color:#65853b',
              );
              $evtArchive.prepend($list);
            }
            $list.html(html);
          }

          // Le bouton "afficher plus" n'est utile que s'il reste des items masqués.
          $evtArchive.find('.js-evt-load').toggleClass('hidden', !has_more);
        })
        .always(() => setLoading(false));
    };

    // Clic sur un filtre catégorie (intercepte le lien de repli)
    $evtFilters.on('click', '.js-evt-filter', function (e) {
      e.preventDefault();
      const term = String($(this).data('term') || '');

      // Bascule : re-cliquer sur le filtre actif le désélectionne.
      state.categorie_evenement = state.categorie_evenement === term ? '' : term;
      syncActive();

      const newUrl = buildUrl();
      if (window.history && window.history.pushState) {
        window.history.pushState({ ...state }, '', newUrl);
      }

      fetchEvenements();
    });

    // "Afficher plus" : révèle les items masqués (pas de pagination serveur).
    $(document).on('click', '.js-evt-load', function (e) {
      e.preventDefault();
      $evtArchive.find('.js-evt-list .evenement-item.hidden').removeClass('hidden');
      $(this).addClass('hidden');
    });
  }
});

/* Swiper */
if (jQuery('section.bloc-image-gauche-droite').length) {
  new Swiper('.bloc-image-gauche-droite .swiper', {
    modules: [Navigation, Pagination],
    slidesPerView: 1,
    loop: true,
    direction: 'horizontal',
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
  });
}

if (jQuery('div.bloc-enumeration-elements').length) {

  new Swiper('.bloc-enumeration-elements .swiper', {
    modules: [Navigation, Pagination],
    slidesPerView: 1.2,
    spaceBetween: 10,
    direction: 'horizontal',
    pagination: {
      el: ".swiper-pagination",
      type: "progressbar", // Type de pagination en barre de progression
    },
    breakpoints: {
      640: {
        slidesPerView: 1,
      },
    },
    clickable: true,
  });
}

/* Swiper */
if (jQuery('section.bloc-formulaire').length) {
  new Swiper('.bloc-formulaire .swiper', {
    modules: [Navigation, Pagination],
    slidesPerView: 1,
    loop: true,
    direction: 'horizontal',
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
  });
}

/* Swiper - Articles récents (bloc ACF "articles-recents") */
if (jQuery('section.bloc-articles-recents').length) {
  $('section.bloc-articles-recents').each(function () {
    const $section = $(this);
    const $swiperEl = $section.find('.articles-recents-swiper').get(0);
    if (!$swiperEl) return;

    new Swiper($swiperEl, {
      modules: [Navigation],
      slidesPerView: 1,
      spaceBetween: 20,
      grabCursor: true,
      watchOverflow: true,
      navigation: {
        prevEl: $section.find('.articles-recents-prev').get(0),
        nextEl: $section.find('.articles-recents-next').get(0),
      },
      breakpoints: {
        640: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 24,
        },
      },
    });
  });
}

/* Swiper - Carrousel de vidéos (bloc générique ACF "carrousel-videos")
 *
 * Ce bloc peut être rendu :
 *  - en standalone (placé directement dans Gutenberg),
 *  - ou inclus via @include depuis un autre bloc (ex: campagne-tourisme).
 * Dans les deux cas, le wrapper porte la classe .bloc-carrousel-videos,
 * donc une seule init suffit pour couvrir tous les cas.
 *
 * Performance : chaque vignette est un simple <img loading="lazy"> (poster ou
 * vignette YouTube par défaut). L'iframe YouTube n'est jamais présente dans le
 * DOM au chargement : Fancybox la crée uniquement à l'ouverture de la modale.
 */
if (jQuery('section.bloc-carrousel-videos').length) {
  $('section.bloc-carrousel-videos').each(function () {
    const $section = $(this);
    const $swiperEl = $section.find('.cv-videos-swiper').get(0);
    if (!$swiperEl) return;

    new Swiper($swiperEl, {
      modules: [Navigation],
      slidesPerView: 1.1,
      spaceBetween: 16,
      grabCursor: true,
      watchOverflow: true,
      navigation: {
        prevEl: $section.find('.cv-videos-prev').get(0),
        nextEl: $section.find('.cv-videos-next').get(0),
      },
      breakpoints: {
        640: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 24,
        },
        1280: {
          slidesPerView: 4,
          spaceBetween: 24,
        },
      },
    });
  });
}

/* Swiper - Slider de profils (bloc ACF "slider-profils") */
if (jQuery('section.bloc-slider-profils').length) {
  $('section.bloc-slider-profils').each(function () {
    const $section = $(this);
    const $swiperEl = $section.find('.sp-swiper').get(0);
    if (!$swiperEl) return;

    const showDots = $section.find('.sp-pagination').length > 0;

    new Swiper($swiperEl, {
      modules: [Navigation, Pagination, Autoplay],
      slidesPerView: 1,
      spaceBetween: 24,
      grabCursor: true,
      watchOverflow: true,
      loop: $section.find('.swiper-slide').length > 1,
      autoplay: {
        delay: 4500,
        pauseOnMouseEnter: true,
      },
      navigation: {
        prevEl: [
          $section.find('.sp-prev').get(0),
          $section.find('.sp-prev-mobile').get(0),
        ],
        nextEl: [
          $section.find('.sp-next').get(0),
          $section.find('.sp-next-mobile').get(0),
        ],
      },
      pagination: showDots ? {
        el: $section.find('.sp-pagination').get(0),
        clickable: true,
      } : false,
    });
  });
}

/* Swiper - Tours étudiant (bloc ACF "tours-etudiant") */
if (jQuery('section.bloc-tours-etudiant').length) {
  $('section.bloc-tours-etudiant').each(function () {
    const $section = $(this);
    const $swiperEl = $section.find('.te-swiper').get(0);
    if (!$swiperEl) return;

    const slideCount = $section.find('.te-swiper .swiper-slide').length;

    new Swiper($swiperEl, {
      modules: [Navigation, Autoplay],
      slidesPerView: 1,
      spaceBetween: 0,
      grabCursor: true,
      watchOverflow: true,
      loop: slideCount > 1,
      autoplay: {
        delay: 3500,
        pauseOnMouseEnter: true,
      },
      navigation: {
        prevEl: $section.find('.te-prev').get(0),
        nextEl: $section.find('.te-next').get(0),
      },
    });
  });
}

/* Swiper - Articles liés (bloc ACF "articles-relies") */
if (jQuery('section.bloc-articles-relies').length) {
  $('section.bloc-articles-relies').each(function () {
    const $section = $(this);
    const $swiperEl = $section.find('.articles-relies-swiper').get(0);
    if (!$swiperEl) return;

    new Swiper($swiperEl, {
      modules: [Navigation],
      slidesPerView: 1,
      spaceBetween: 20,
      grabCursor: true,
      watchOverflow: true,
      navigation: {
        prevEl: $section.find('.articles-relies-prev').get(0),
        nextEl: $section.find('.articles-relies-next').get(0),
      },
      breakpoints: {
        640: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 24,
        },
      },
    });
  });
}

/* Swiper - Carrousel */
if (jQuery('section.bloc-carrousel').length) {
  $('.bloc-carrousel').each(function () {
    const $this = $(this);
    const id = $this.attr('id');
    const slideCount = $this.find('.swiper-slide').length; // Compte les slides

    let slidesPerViewDefault = slideCount === 2 ? 2 : 1; // Par défaut, 2 slides visibles si seulement 2 slides

    if ($this.find('.swiper-container').length) {
      new Swiper(`#${id} .swiper-container`, {
        modules: [Navigation, Pagination],
        slidesPerView: slidesPerViewDefault,
        spaceBetween: 0,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        breakpoints: {
          1024: {
            slidesPerView: slideCount === 2 ? 2 : 3, // Ajuste à 2 slides si seulement 2 slides
            spaceBetween: 30,
          },
        },
        loop: true,
      });
    }
  });
}

/* Swiper - Liste d'icônes */
if ($('.bloc-ico .swiper-container-carrousel').length) {
  new Swiper('.bloc-ico .swiper-container-carrousel', {
    modules: [Navigation, Pagination],
    slidesPerView: 1,
    spaceBetween: 10,
    pagination: {
      el: '.swiper-pagination-carrousel',
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next-carrousel',
      prevEl: '.swiper-button-prev-carrousel',
    },
    loop: true,
  });
}

/* Swiper - Liste d'icônes */
if ($('.bloc-ico .swiper-container').length) {
  new Swiper('.bloc-ico .swiper-container', {
    modules: [Navigation, Pagination],
    slidesPerView: 1,
    spaceBetween: 10,
    pagination: {
      el: '.swiper-pagination-custom',
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next-custom',
      prevEl: '.swiper-button-prev-custom',
    },
    loop: true,
  });
}



/* Swiper - Liste d'icônes */
if ($('.bloc-temoignages .swiper-container').length) {
  new Swiper('.bloc-temoignages .swiper-container', {
    modules: [Navigation, Pagination],
    slidesPerView: 1,
    spaceBetween: 10,
    pagination: {
      el: '.swiper-pagination-tem',
      clickable: true,
    },
    breakpoints: {
      1024: {
        slidesPerView: 2,
        spaceBetween: 30,
      },
    },
    navigation: {
      nextEl: '.swiper-button-next-tem',
      prevEl: '.swiper-button-prev-tem',
    },
    loop: true,
  });
}



if ($('.bloc-video').length) {
  // Compter le nombre de slides
  const slideCount = $('.bloc-video-swiper .swiper-slide').length;

  var videoSwiper = new Swiper('.bloc-video-swiper', {
    modules: [Navigation, Pagination],
    slidesPerView: Math.min(slideCount, 1), // Ajuster selon le nombre de slides
    spaceBetween: 24,
    navigation: {
      nextEl: '.swiper-button-next-video',
      prevEl: '.swiper-button-prev-video',
    },
    pagination: {
      el: '.swiper-pagination-video',
      clickable: true,
    },
    breakpoints: {
      768: {
        spaceBetween: 24,
        slidesPerView: Math.min(slideCount, 2), // Max 2, mais ajusté selon le nombre réel
      },
      1280: {
        spaceBetween: 24,
        slidesPerView: Math.min(slideCount, 3), // Max 3, mais ajusté selon le nombre réel
      },
    },
  });
  videoSwiper;
}

$('.bloc-video').each(function () {
  const $bloc = $(this);

  $bloc.find('.js-video-wrapper').each(function () {
    const $wrapper = $(this);
    const $video = $wrapper.find('.js-video');
    const $overlay = $wrapper.find('.js-play-overlay');

    if ($video.length && $overlay.length) {
      // Masquer les contrôles natifs au départ
      $video.prop('controls', false);

      // ▶️ Clic sur overlay pour lancer
      $overlay.on('click', function (e) {
        e.preventDefault();

        // Stopper les autres vidéos dans ce bloc
        $bloc.find('.js-video').each(function () {
          const $v = $(this);
          if (!$v.is($video)) {
            $v.get(0).pause();
            $v.get(0).currentTime = 0;
            $v.prop('controls', false);
            $v.closest('.js-video-wrapper').find('.js-play-overlay').removeClass('hidden');
          }
        });

        $video.get(0).play();
        $overlay.addClass('hidden');
      });

      // ⏸️ Clic sur la vidéo pour pause, overlay revient
      $video.on('click', function (e) {
        e.preventDefault();
        const vid = this;

        if (!vid.paused) {
          vid.pause();
          $overlay.removeClass('hidden');
        }
      });

      // Si la vidéo s’arrête toute seule (fin), on remet l’overlay
      $video.on('ended', function () {
        $overlay.removeClass('hidden');
      });
    }
  });
});



import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

// gsap
document.addEventListener("DOMContentLoaded", function () {
  const tl = gsap.timeline({
    defaults: {
      ease: "power2.out",
      duration: 0.6,
    },
  });

  tl

    // Header complet
    .from("header.banner", {
      y: -50,
      opacity: 0,
    })

    // Logo (desktop et mobile, à toi de filtrer selon viewport)
    .from("header .brand img", {
      opacity: 0,
      scale: 0.8,
    }, "-=0.3")

    // Liens de nav top (desktop)
    .from("nav#menu-top li, form", {
      opacity: 0,
      y: 20,
      stagger: 0.1,
    }, "-=0.4")

    // Barre blanche en dessous
    .from("header section.bg-white", {
      opacity: 0,
      y: 20,
    }, "-=0.4")

    // Bouton search (mobile ou desktop)
    .from(".search", {
      opacity: 0,
      x: 20,
    }, "-=0.3");

});



gsap.registerPlugin(ScrollTrigger);

gsap.utils.toArray(".gsap-stagger-childrens").forEach((container) => {
  const children = container.querySelectorAll(":scope > *");

  gsap.from(".bloc-en-tete-de-page.accueil .surtitre, .bloc-en-tete-de-page.accueil .titre, .bloc-en-tete-de-page.accueil .sous-titre, .bloc-en-tete-de-page.accueil .texte", {
    scrollTrigger: {
      trigger: container,
      start: "top 85%", // joue quand l’élément entre dans le viewport
      toggleActions: "play none none none",
    },
    opacity: 0,
    y: 20,
    duration: 2,
    ease: "power2.out",
    stagger: 0.2,
    delay: 1.5,
  })

  gsap.from(children, {
    scrollTrigger: {
      trigger: container,
      start: "top 85%", // joue quand l’élément entre dans le viewport
      toggleActions: "play none none none",
    },
    opacity: 0,
    x: 50,
    duration: 1,
    ease: "power2.out",
    stagger: 0.2,
    delay: 2.3,
  });
});

gsap.utils.toArray(".gsap-stagger-childrens-no-delay").forEach((container) => {
  const children = container.querySelectorAll(":scope > *");

  gsap.from(children, {
    scrollTrigger: {
      trigger: container,
      start: "top 85%", // joue quand l’élément entre dans le viewport
      toggleActions: "play none none none",
    },
    opacity: 0,
    y: 20,
    duration: 2,
    ease: "power2.out",
    stagger: 0.2,
  });
});


gsap.utils.toArray(".animate").forEach((el) => {
  gsap.from(el, {
    scrollTrigger: {
      trigger: el,
      start: "top 85%",
      toggleActions: "play none none none",
    },
    opacity: 0,
    y: 20,
    scale: 0.98,
    duration: 0.6,
    ease: "power2.out",
  });
});





/* En-tête de page d'accueil - Animation GSAP de la flèche, en Desktop, qui indique les répéteurs de CTA de droite */
document.addEventListener('DOMContentLoaded', () => {
  const paths = document.querySelectorAll('.arrow-draw path');
  if (paths.length < 2) return;

  // Path 0 = trait principal
  const mainPath = paths[0];
  const mainLength = mainPath.getTotalLength();

  mainPath.style.strokeDasharray = mainLength;
  mainPath.style.strokeDashoffset = -mainLength;
  mainPath.style.opacity = 0;

  // Path 1 = petit bout de flèche
  const arrowHead = paths[1];
  const headLength = arrowHead.getTotalLength();

  arrowHead.style.strokeDasharray = headLength;
  arrowHead.style.strokeDashoffset = -headLength; // ← inversion aussi ici
  arrowHead.style.opacity = 0;

  // Animate main path
  gsap.to(mainPath, {
    strokeDashoffset: 0,
    opacity: 1,
    duration: 2,
    ease: 'power2.out',
    delay: 2,
  });

  // Animate arrow head after
  gsap.to(arrowHead, {
    strokeDashoffset: 0,
    opacity: 1,
    duration: 0.8,
    ease: 'power2.out',
    delay: 4,
  });
});



/* Bloc d'en tête de page standard - Animation GSAP du soulignement */
document.addEventListener('DOMContentLoaded', () => {
  const svgs = document.querySelectorAll('.soulignement-svg');

  svgs.forEach(svg => {
    const paths = svg.querySelectorAll('path');

    paths.forEach(path => {
      const length = path.getTotalLength();
      path.style.strokeDasharray = length;
      path.style.strokeDashoffset = length;
      path.style.opacity = 0;
    });

    ScrollTrigger.create({
      trigger: svg,
      start: 'top 80%',
      once: true,
      onEnter: () => {
        paths.forEach((path, i) => {
          gsap.to(path, {
            strokeDashoffset: 0,
            opacity: 1,
            duration: 1.5,
            ease: 'power2.out',
            delay: i * 0.1, // petit stagger si plusieurs paths
          });
        });
      },
    });
  });
});


/* Animation pour entourer le mot d'un titre avec un SVG */
document.addEventListener('DOMContentLoaded', () => {
  const template = document.querySelector('#svg-template');
  const highlights = document.querySelectorAll('.titre .highlight');

  highlights.forEach((el) => {
    el.style.position = 'relative';

    // Clone du SVG
    const svg = template.querySelector('svg').cloneNode(true);
    el.appendChild(svg);

    const path = svg.querySelector('path');
    if (!path) return;

    // Choix de la classe en fonction du nombre de lettres
    const n = (el.textContent || '').replace(/\s+/g, '').length;
    if (n > 7 && n <= 10) {
      svg.classList.add('grand');
    } else if (n > 10 && n <= 12) {
      svg.classList.add('tres-grand');
    } else if (n > 12) {
      svg.classList.add('enorme');
    }

    const length = path.getTotalLength();
    path.style.strokeDasharray = length;
    path.style.strokeDashoffset = length;
    path.style.opacity = 0;

    gsap.to(path, {
      scrollTrigger: {
        trigger: el,
        start: 'top 80%',
        once: true,
      },
      strokeDashoffset: 0,
      opacity: 1,
      duration: 1.5,
      ease: 'power2.out',
    });
  });
});

// Page d'accueil - Barre blanche qui apparaît au scroll
jQuery(document).ready(function ($) {
  if ($("body").hasClass("home")) { // uniquement sur la home
    var $barre = $("section#barre-blanche");
    $barre.hide(); // caché par défaut

    $(window).on("scroll resize", function () {
      var windowWidth = $(window).width();
      var scrolled = $(this).scrollTop();

      if (windowWidth >= 1024) { // seulement en desktop / lg+
        if (scrolled > $(window).height()) {
          if (!$barre.is(":visible")) {
            $barre.stop(true, true).slideDown(400);
          }
        } else {
          if ($barre.is(":visible")) {
            $barre.stop(true, true).slideUp(400);
          }
        }
      } else {
        // si on est en mobile/tablette, on s'assure que la barre est cachée
        if ($barre.is(":visible")) {
          $barre.stop(true, true).slideUp(0);
        }
      }
    });
  }
});

/* ======================================================
 | Forum communautaire
 |======================================================*/
jQuery(document).ready(function ($) {
  var $page = $('.js-forum-page');
  if (!$page.length) return;

  var ajaxUrl = $page.data('ajax-url');
  var nonce = $page.data('nonce');
  var isLoggedIn = $page.data('logged-in') === 1 || $page.data('logged-in') === '1';

  var currentForumId = 0;
  var currentPage = 1;
  var currentSort = 'newest';
  var currentThematique = '';
  var isLoading = false;

  var $topicsList = $page.find('.js-forum-topics-list');
  var $pagination = $page.find('.js-forum-pagination');
  var $totalCount = $page.find('.js-forum-total-count');
  var $activeTitle = $page.find('.js-forum-active-title');

  // ---- Collapsible nav sections (open by default) ----
  $page.find('.js-forum-section-toggle').addClass('is-open');

  $page.on('click', '.js-forum-section-toggle', function () {
    $(this).toggleClass('is-open');
  });

  // ---- File input: show selected filename ----
  $page.on('change', '.js-file-input', function () {
    var $nameSpan = $(this).closest('div').find('.js-file-name');
    if (this.files && this.files[0]) {
      $nameSpan.text(this.files[0].name).removeClass('hidden');
    } else {
      $nameSpan.text('').addClass('hidden');
    }
  });
  var $topicDetail = $page.find('.js-forum-topic-detail');
  var $newTopicForm = $page.find('.js-forum-new-topic-form');
  var forumScrollOffset = 40; // espace supplementaire au-dessus du forum lors du scroll

  // Masque automatiquement le bouton Modifier quand le délai d'édition BBPress expire.
  function initEditLockTimers($container) {
    $container.find('.js-forum-edit-post[data-edit-lock-expires]').each(function () {
      var $btn = $(this);
      var expires = parseInt($btn.data('edit-lock-expires'), 10);
      if (!expires) return;
      var remaining = expires * 1000 - Date.now();
      function hideEditBtn() {
        $btn.prev('.js-edit-sep').remove();
        $btn.remove();
      }
      if (remaining <= 0) {
        hideEditBtn();
      } else {
        setTimeout(hideEditBtn, remaining);
      }
    });
  }

  function scrollToForum() {
    var $layout = $page.find('.forum-layout');
    if ($layout.length) {
      var headerH = $('.banner-logged-in').outerHeight() || 0;
      $('html, body').animate({ scrollTop: $layout.offset().top - headerH - forumScrollOffset }, 400);
    }
  }

  // Sync counts from detail AJAX response to the hidden list card
  function syncCardCounts(topicId, data) {
    var $card = $page.find('.js-forum-topic-card[data-topic-id="' + topicId + '"]');
    if (!$card.length) return;
    if (data.reply_count !== undefined) {
      var rc = data.reply_count;
      $card.find('.js-forum-reply-count').text(rc + ' réponse' + (rc > 1 ? 's' : ''));
    }
    if (data.view_count !== undefined) {
      var vc = data.view_count;
      $card.find('.js-forum-view-count').text(vc + ' vue' + (vc > 1 ? 's' : ''));
    }
    if (data.like_count !== undefined) {
      var lc = data.like_count;
      $card.find('.js-forum-like-count').each(function () {
        var label = $(this).data('label');
        if (label) {
          $(this).text(lc + ' ' + label + (lc > 1 ? 's' : ''));
        }
      });
    }
  }

  var loaderHtml = '<div class="js-forum-loader flex justify-center items-center py-12"><svg class="animate-spin h-8 w-8 text-gray-400" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle><path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"></path></svg></div>';

  // ---- Auto-open topic from URL param (notifications) ----
  (function () {
    var params = new URLSearchParams(window.location.search);
    var openTopicId = parseInt(params.get('open_topic'), 10);
    if (!openTopicId) return;

    // Nettoyer l'URL (retirer le param sans recharger)
    params.delete('open_topic');
    var cleanUrl = window.location.pathname + (params.toString() ? '?' + params.toString() : '');
    if (window.history && window.history.replaceState) {
      window.history.replaceState(null, '', cleanUrl);
    }

    // Ouvrir le topic directement
    $topicsList.hide();
    $pagination.hide();
    $newTopicForm.addClass('hidden');
    $topicDetail.removeClass('hidden').show().html(loaderHtml);
    history.pushState({ forumView: 'detail' }, '');

    $.ajax({
      url: ajaxUrl,
      type: 'POST',
      dataType: 'json',
      data: {
        action: 'forum_get_topic_detail',
        nonce: nonce,
        topic_id: openTopicId,
      },
    }).done(function (res) {
      if (res && res.success) {
        $topicDetail.html(res.data.html);
        initEditLockTimers($topicDetail);
        syncCardCounts(openTopicId, res.data);
      } else {
        $topicDetail.html('<p>Erreur : impossible de charger la discussion.</p>');
      }
    }).fail(function () {
      $topicDetail.html('<p>Erreur de connexion.</p>');
    });
  })();

  // ---- Custom dropdown component ----
  // Toggle open/close
  $page.on('click', '.js-custom-dropdown-trigger', function (e) {
    e.preventDefault();
    e.stopPropagation();
    var $dropdown = $(this).closest('.js-custom-dropdown');
    var $menu = $dropdown.find('.js-custom-dropdown-menu');
    var $chevron = $dropdown.find('.js-custom-dropdown-chevron');

    // Close all other dropdowns first
    $page.find('.js-custom-dropdown-menu').not($menu).addClass('hidden');
    $page.find('.js-custom-dropdown-chevron').not($chevron).removeClass('rotate-180');

    $menu.toggleClass('hidden');
    $chevron.toggleClass('rotate-180');
  });

  // Select an option
  $page.on('click', '.js-custom-dropdown-option', function (e) {
    e.preventDefault();
    e.stopPropagation();
    var $option = $(this);
    var $dropdown = $option.closest('.js-custom-dropdown');
    var value = $option.data('value');
    var label = $option.text().trim();

    $dropdown.find('.js-custom-dropdown-value').val(value).removeData('autofilled').trigger('change');
    $dropdown.find('.js-custom-dropdown-label').text(label);
    $dropdown.find('.js-custom-dropdown-menu').addClass('hidden');
    $dropdown.find('.js-custom-dropdown-chevron').removeClass('rotate-180');

    // Update pill style when selected
    var $trigger = $dropdown.find('.js-custom-dropdown-trigger');
    if ($trigger.hasClass('forum-badge-btn')) {
      $trigger.toggleClass('is-selected', !!value);
    } else if ($trigger.hasClass('rounded-full')) {
      if (value) {
        $trigger.removeClass('border-gray-300 text-gray-500').addClass('border-[#7B8B5E] text-[#7B8B5E]');
      } else {
        $trigger.removeClass('border-[#7B8B5E] text-[#7B8B5E]').addClass('border-gray-300 text-gray-500');
      }
    }
  });

  // Close dropdown when clicking outside
  $(document).on('click', function () {
    $page.find('.js-custom-dropdown-menu').addClass('hidden');
    $page.find('.js-custom-dropdown-chevron').removeClass('rotate-180');
  });

  // ---- Helper: sync mobile filter label with current selection ----
  function syncMobileFilter(label) {
    var $mobileLabel = $page.find('.js-mobile-filter-label');
    var $mobileBtn = $page.find('.js-mobile-filter-toggle');
    $mobileLabel.text(label);
    $activeTitle.text(label);
    if (label === 'Toutes les discussions') {
      $mobileBtn.removeClass('is-filtered');
    } else {
      $mobileBtn.addClass('is-filtered');
    }
    // Sync active state on mobile dropdown options
    $page.find('.js-mobile-filter-option').removeClass('active');
    if (currentForumId && !currentThematique) {
      $page.find('.js-mobile-filter-option[data-forum-id="' + currentForumId + '"]').addClass('active');
    } else if (currentThematique) {
      $page.find('.js-mobile-filter-option[data-thematique="' + currentThematique + '"]').addClass('active');
    } else {
      $page.find('.js-mobile-filter-option[data-forum-id="0"]').addClass('active');
    }
  }

  // ---- Navigation click (desktop sidebar) ----
  $page.on('click', '.js-forum-nav-link', function (e) {
    e.preventDefault();
    var $link = $(this);

    if ($link.hasClass('forum-locked')) return;

    var deselect = $link.hasClass('active') && !$link.hasClass('js-forum-nav-all');

    $page.find('.js-forum-nav-link').removeClass('active');
    if (deselect) {
      $page.find('.js-forum-nav-all').addClass('active');
    } else {
      $link.addClass('active');
    }

    currentForumId = deselect ? 0 : (parseInt($link.data('forum-id'), 10) || 0);
    currentPage = 1;
    currentThematique = '';
    $page.find('.js-forum-thematique-link').removeClass('active');

    $topicDetail.addClass('hidden').empty();
    $newTopicForm.addClass('hidden');
    $topicsList.show();
    $pagination.show();

    syncMobileFilter(deselect ? 'Toutes les discussions' : $link.text().trim());
    loadTopics();
    scrollToForum();
  });

  // ---- Sort change (custom dropdown triggers change on hidden input) ----
  $page.on('change', '.js-forum-sort', function () {
    currentSort = $(this).val();
    currentPage = 1;
    if (!$topicDetail.hasClass('hidden')) {
      history.replaceState(null, '');
      backToList();
    }
    loadTopics();
  });

  // ---- Thématique link click (left nav) ----
  $page.on('click', '.js-forum-thematique-link', function (e) {
    e.preventDefault();
    var $link = $(this);
    var slug = $link.data('thematique') || '';

    // Toggle: if already active, deselect
    if ($link.hasClass('active')) {
      $link.removeClass('active');
      currentThematique = '';
    } else {
      $page.find('.js-forum-thematique-link').removeClass('active');
      $link.addClass('active');
      currentThematique = slug;
    }

    currentForumId = 0;
    currentPage = 1;
    $page.find('.js-forum-nav-link').removeClass('active');
    $page.find('.js-forum-nav-all').addClass('active');
    $topicDetail.addClass('hidden').empty();
    $newTopicForm.addClass('hidden');
    $topicsList.show();
    $pagination.show();
    syncMobileFilter(currentThematique ? $link.text().trim() : 'Toutes les discussions');
    loadTopics();
    scrollToForum();
  });

  // ---- Mobile filter toggle ----
  $page.on('click', '.js-mobile-filter-toggle', function () {
    var $dropdown = $page.find('.js-mobile-filter-dropdown');
    var $chevron = $(this).find('.js-mobile-filter-chevron');
    $dropdown.toggleClass('hidden');
    $chevron.toggleClass('rotate-180');
  });

  // ---- Mobile filter option click ----
  $page.on('click', '.js-mobile-filter-option', function (e) {
    e.preventDefault();
    var $opt = $(this);

    if ($opt.hasClass('forum-locked')) return;

    var type = $opt.data('type');
    var label = $opt.text().trim();

    // Reset states
    $page.find('.js-mobile-filter-option').removeClass('active');
    $opt.addClass('active');
    currentPage = 1;

    if (type === 'forum') {
      currentForumId = parseInt($opt.data('forum-id'), 10) || 0;
      currentThematique = '';
      // Sync desktop sidebar
      $page.find('.js-forum-nav-link').removeClass('active');
      $page.find('.js-forum-thematique-link').removeClass('active');
      $page.find('.js-forum-nav-link[data-forum-id="' + currentForumId + '"]').addClass('active');
    } else if (type === 'thematique') {
      currentThematique = $opt.data('thematique') || '';
      currentForumId = 0;
      // Sync desktop sidebar
      $page.find('.js-forum-nav-link').removeClass('active');
      $page.find('.js-forum-nav-all').addClass('active');
      $page.find('.js-forum-thematique-link').removeClass('active');
      $page.find('.js-forum-thematique-link[data-thematique="' + currentThematique + '"]').addClass('active');
    }

    $topicDetail.addClass('hidden').empty();
    $newTopicForm.addClass('hidden');
    $topicsList.show();
    $pagination.show();

    // Close dropdown and update label
    $page.find('.js-mobile-filter-dropdown').addClass('hidden');
    $page.find('.js-mobile-filter-chevron').removeClass('rotate-180');
    syncMobileFilter(label);
    loadTopics();
  });

  // Close mobile filter dropdown when clicking outside
  $(document).on('click', function (e) {
    if (!$(e.target).closest('.forum-mobile-filters, .js-mobile-filter-dropdown').length) {
      $page.find('.js-mobile-filter-dropdown').addClass('hidden');
      $page.find('.js-mobile-filter-chevron').removeClass('rotate-180');
    }
  });

  // ---- Mobile filter reset ----
  $page.on('click', '.js-mobile-filter-reset', function (e) {
    e.preventDefault();
    e.stopPropagation();
    currentForumId = 0;
    currentThematique = '';
    currentPage = 1;
    $page.find('.js-forum-nav-link').removeClass('active');
    $page.find('.js-forum-nav-all').addClass('active');
    $page.find('.js-forum-thematique-link').removeClass('active');
    $page.find('.js-mobile-filter-option').removeClass('active');
    $page.find('.js-mobile-filter-option[data-forum-id="0"]').addClass('active');
    $page.find('.js-mobile-filter-dropdown').addClass('hidden');
    $page.find('.js-mobile-filter-chevron').removeClass('rotate-180');
    syncMobileFilter('Toutes les discussions');
    $topicDetail.addClass('hidden').empty();
    $newTopicForm.addClass('hidden');
    $topicsList.show();
    $pagination.show();
    loadTopics();
    scrollToForum();
  });

  // ---- Badge category click → filter by forum ----
  $page.on('click', '.js-badge-forum-filter', function (e) {
    e.preventDefault();
    e.stopPropagation();
    var forumId = parseInt($(this).data('forum-id'), 10) || 0;
    var label = $(this).text().trim();
    currentForumId = forumId;
    currentThematique = '';
    currentPage = 1;
    $page.find('.js-forum-nav-link').removeClass('active');
    $page.find('.js-forum-thematique-link').removeClass('active');
    if (forumId) {
      $page.find('.js-forum-nav-link[data-forum-id="' + forumId + '"]').addClass('active');
    } else {
      $page.find('.js-forum-nav-all').addClass('active');
    }
    $topicDetail.addClass('hidden').empty();
    $newTopicForm.addClass('hidden');
    $topicsList.show();
    $pagination.show();
    syncMobileFilter(label);
    loadTopics();
    scrollToForum();
  });

  // ---- Badge thematique click → filter by thematique ----
  $page.on('click', '.js-badge-thematique-filter', function (e) {
    e.preventDefault();
    e.stopPropagation();
    var slug = $(this).data('thematique-slug');
    var label = $(this).text().trim();
    if (!slug) return;
    currentForumId = 0;
    currentThematique = slug;
    currentPage = 1;
    $page.find('.js-forum-nav-link').removeClass('active');
    $page.find('.js-forum-nav-all').addClass('active');
    $page.find('.js-forum-thematique-link').removeClass('active');
    $page.find('.js-forum-thematique-link[data-thematique="' + slug + '"]').addClass('active');
    $topicDetail.addClass('hidden').empty();
    $newTopicForm.addClass('hidden');
    $topicsList.show();
    $pagination.show();
    syncMobileFilter(label);
    loadTopics();
    scrollToForum();
  });

  // ---- Pagination click ----
  $page.on('click', '.js-forum-page-btn', function () {
    if ($(this).is(':disabled') || $(this).prop('disabled')) return;
    currentPage = parseInt($(this).data('page'), 10) || 1;
    loadTopics();
    scrollToForum();
  });

  // ---- Load topics via AJAX ----

  function loadTopics() {
    if (isLoading) return;
    isLoading = true;
    $topicsList.html(loaderHtml);

    $.ajax({
      url: ajaxUrl,
      type: 'POST',
      dataType: 'json',
      data: {
        action: 'forum_get_topics',
        nonce: nonce,
        forum_id: currentForumId,
        page: currentPage,
        orderby: currentSort,
        thematique: currentThematique,
      },
    }).done(function (res) {
      if (res && res.success) {
        var d = res.data;
        $topicsList.html(d.html || '<p class="js-forum-empty">Aucune discussion pour le moment.</p>');
        $pagination.html(d.pagination || '');
        var total = d.total || 0;
        $totalCount.text(total + ' discussion' + (total > 1 ? 's' : '') + ' active' + (total > 1 ? 's' : ''));
      }
    }).always(function () {
      isLoading = false;
    });
  }

  // ---- Topic card click → open detail inline ----
  function openTopicDetail(topicId) {
    if (!topicId) return;

    $topicsList.hide();
    $pagination.hide();
    $newTopicForm.addClass('hidden');
    $topicDetail.removeClass('hidden').show().html(loaderHtml);
    history.pushState({ forumView: 'detail' }, '');
    scrollToForum();

    $.ajax({
      url: ajaxUrl,
      type: 'POST',
      dataType: 'json',
      data: {
        action: 'forum_get_topic_detail',
        nonce: nonce,
        topic_id: topicId,
      },
    }).done(function (res) {
      if (res && res.success) {
        $topicDetail.html(res.data.html);
        initEditLockTimers($topicDetail);
        syncCardCounts(topicId, res.data);
      } else {
        $topicDetail.html('<p>Erreur: ' + ((res && res.data && res.data.message) || 'Impossible de charger le topic.') + '</p>');
      }
    }).fail(function () {
      $topicDetail.html('<p>Erreur de connexion.</p>');
    });
  }

  $page.on('click', '.js-forum-topic-card', function () {
    openTopicDetail($(this).data('topic-id'));
  });

  // ---- Back to list ----
  function backToList() {
    $topicDetail.addClass('hidden').empty();
    $topicsList.show();
    $pagination.show();
  }

  $page.on('click', '.js-forum-back-to-list', function () {
    history.back();
  });

  window.addEventListener('popstate', function () {
    if (!$topicDetail.hasClass('hidden')) {
      backToList();
    }
  });

  // ---- Reply sort dropdown (custom dropdown triggers change on hidden input) ----
  $page.on('change', '.js-forum-reply-sort', function () {
    var $input = $(this);
    var topicId = $input.data('topic-id');
    var replySort = $input.val();
    var $repliesList = $page.find('.js-forum-replies-list');

    $repliesList.html(loaderHtml);

    $.ajax({
      url: ajaxUrl,
      type: 'POST',
      dataType: 'json',
      data: {
        action: 'forum_get_topic_detail',
        nonce: nonce,
        topic_id: topicId,
        reply_sort: replySort,
      },
    }).done(function (res) {
      if (res && res.success) {
        $topicDetail.html(res.data.html);
        initEditLockTimers($topicDetail);
        syncCardCounts(topicId, res.data);
      }
    });
  });

  // ---- Submit reply ----
  $page.on('click', '.js-forum-submit-reply', function () {
    var $section = $(this).closest('.js-forum-reply-section');
    var topicId = $section.data('topic-id');
    var $textarea = $section.find('.js-forum-reply-content');
    var content = $textarea.val().trim();
    var $msg = $section.find('.js-forum-reply-message');

    if (!content) {
      $msg.removeClass('hidden').text('Veuillez écrire une réponse.').css('color', '#ef4444');
      return;
    }

    var $btn = $(this);
    var btnOriginalHtml = $btn.html();
    $btn.prop('disabled', true).html('<span class="forum-btn-spinner"></span> Publication...');

    var formData = new FormData();
    formData.append('action', 'forum_post_reply');
    formData.append('nonce', nonce);
    formData.append('topic_id', topicId);
    formData.append('reply_content', window.convertMentionsForSubmit ? window.convertMentionsForSubmit($textarea[0]) : content);

    var fileInput = $section.find('.js-forum-reply-attachment')[0];
    if (fileInput && fileInput.files[0]) {
      formData.append('reply_attachment', fileInput.files[0]);
    }

    $.ajax({
      url: ajaxUrl,
      type: 'POST',
      dataType: 'json',
      data: formData,
      processData: false,
      contentType: false,
    }).done(function (res) {
      if (res && res.success) {
        $textarea.val('');
        $section.find('.js-forum-reply-attachment').val('');
        $msg.removeClass('hidden').text('Réponse publiée.').css('color', '#22c55e');
        if (res.data.html) {
          var $newReply = $(res.data.html);
          $section.before($newReply);
          initEditLockTimers($newReply);
        }
        // Sync reply count in both detail and list card
        $page.find('.js-forum-reply-count[data-topic-id="' + topicId + '"]').each(function () {
          var current = parseInt($(this).text()) || 0;
          var next = current + 1;
          $(this).text(next + ' réponse' + (next > 1 ? 's' : ''));
        });
      } else {
        $msg.removeClass('hidden').text((res && res.data && res.data.message) || 'Erreur.').css('color', '#ef4444');
      }
    }).fail(function () {
      $msg.removeClass('hidden').text('Erreur de connexion.').css('color', '#ef4444');
    }).always(function () {
      $btn.prop('disabled', false).html(btnOriginalHtml);
    });
  });

  // ---- Like toggle ----
  $page.on('click', '.js-forum-like-btn', function (e) {
    e.stopPropagation();
    e.preventDefault();

    if (!isLoggedIn) return;

    var $btn = $(this);
    var postId = $btn.data('post-id');
    if (!postId || $btn.data('liking')) return;

    $btn.data('liking', true);

    $.ajax({
      url: ajaxUrl,
      type: 'POST',
      dataType: 'json',
      data: {
        action: 'forum_toggle_like',
        nonce: nonce,
        post_id: postId,
      },
    }).done(function (res) {
      if (res && res.success) {
        var count = res.data.like_count;
        var userLiked = res.data.user_liked;

        // Update ALL like elements for the same post on the page
        $page.find('.js-forum-like-btn[data-post-id="' + postId + '"]').each(function () {
          var $likeBtn = $(this);
          $likeBtn.toggleClass('liked', userLiked);
          $likeBtn.toggleClass('is-liked', userLiked);

          // Update heart SVG fill for big action buttons
          // if ($likeBtn.hasClass('forum-action-like')) {
          //   $likeBtn.find('svg').attr('fill', userLiked ? 'currentColor' : 'none');
          // }

          $likeBtn.find('.js-forum-like-count').each(function () {
            var $el = $(this);
            var label = $el.data('label');
            if (label) {
              $el.text(count + ' ' + label + (count > 1 ? 's' : ''));
            } else {
              $el.text(count);
            }
          });
        });
      }
    }).always(function () {
      $btn.data('liking', false);
    });
  });

  // ---- New topic button ----
  function presetCreateDropdown(name, value, defaultLabel) {
    var $dropdown = $newTopicForm.find('.js-custom-dropdown[data-name="' + name + '"]');
    var $value = $dropdown.find('.js-custom-dropdown-value');
    if (!$dropdown.length || ($value.val() && !$value.data('autofilled'))) return;

    var $option = value
      ? $dropdown.find('.js-custom-dropdown-option[data-value="' + value + '"]')
      : $();
    var matched = $option.length > 0;

    $value.val(matched ? value : '');
    if (matched) {
      $value.data('autofilled', true);
    } else {
      $value.removeData('autofilled');
    }
    $dropdown.find('.js-custom-dropdown-label').text(matched ? $option.text().trim() : defaultLabel);
    $dropdown.find('.js-custom-dropdown-trigger').toggleClass('is-selected', matched);
  }

  function presetCreateForm() {
    presetCreateDropdown('forum_id', currentForumId, 'Sélectionne la catégorie');
    presetCreateDropdown('topic_thematique', currentThematique, 'Sélectionne la thématique');
  }

  $page.on('click', '.js-forum-new-topic-btn', function () {
    $topicsList.hide();
    $pagination.hide();
    $topicDetail.addClass('hidden');
    $newTopicForm.removeClass('hidden').show();
    presetCreateForm();
  });

  // ---- Cancel new topic ----
  $page.on('click', '.js-forum-cancel-new', function () {
    $newTopicForm.addClass('hidden');
    $topicsList.show();
    $pagination.show();
  });

  // ---- Submit new topic ----
  $page.on('submit', '.js-forum-create-form', function (e) {
    e.preventDefault();
    var $form = $(this);
    var $msg = $form.find('.js-forum-create-message');
    var $btn = $form.find('.js-forum-submit-new');

    // Validate required custom dropdowns
    var forumId = $form.find('input[name="forum_id"]').val();
    if (!forumId) {
      $msg.removeClass('hidden').text('Veuillez sélectionner une catégorie.').css('color', '#ef4444');
      return;
    }

    var formData = new FormData($form[0]);
    // Convertir les @mentions avant envoi
    var $topicTextarea = $form.find('textarea[name="topic_content"]');
    if ($topicTextarea.length && window.convertMentionsForSubmit) {
      formData.set('topic_content', window.convertMentionsForSubmit($topicTextarea[0]));
    }
    formData.append('action', 'forum_create_topic');
    formData.append('nonce', nonce);

    var btnOriginalText = $btn.text();
    $btn.prop('disabled', true).html('<span class="forum-btn-spinner"></span> Publication...');
    $msg.addClass('hidden');

    $.ajax({
      url: ajaxUrl,
      type: 'POST',
      data: formData,
      processData: false,
      contentType: false,
      dataType: 'json',
    }).done(function (res) {
      if (res && res.success) {
        $msg.removeClass('hidden').text(res.data.message || 'Discussion créée.').css('color', '#22c55e');
        $form[0].reset();
        // Reset custom dropdowns
        $form.find('.js-custom-dropdown-value').val('');
        $form.find('.js-custom-dropdown-label').each(function () {
          var $dd = $(this).closest('.js-custom-dropdown');
          var name = $dd.data('name');
          $(this).text(name === 'forum_id' ? 'Catégorie' : 'Thématique');
        });
        $form.find('.js-custom-dropdown-trigger.forum-badge-btn').removeClass('is-selected');
        $form.find('.js-custom-dropdown-trigger.rounded-full')
          .removeClass('border-[#7B8B5E] text-[#7B8B5E]').addClass('border-gray-300 text-gray-500');
        setTimeout(function () {
          var newTopicId = res.data && res.data.topic_id;
          var isPending  = !!(res.data && res.data.pending);

          if (newTopicId && !isPending) {
            $newTopicForm.addClass('hidden');
            loadTopics();
            openTopicDetail(newTopicId);
            return;
          }

          // Reset all filters before going back to list
          currentForumId = 0;
          currentThematique = '';
          currentPage = 1;
          $page.find('.js-forum-nav-link').removeClass('active');
          $page.find('.js-forum-nav-all').addClass('active');
          $page.find('.js-forum-thematique-link').removeClass('active');
          var $sortDropdown = $page.find('.js-custom-dropdown[data-name="topics_sort"]');
          $sortDropdown.find('.js-custom-dropdown-value').val('newest');
          $sortDropdown.find('.js-custom-dropdown-label').text('Trier par');
          currentSort = 'newest';
          syncMobileFilter('Toutes les discussions');
          $newTopicForm.addClass('hidden');
          $topicsList.show();
          $pagination.show();
          loadTopics();
          scrollToForum();
        }, 1500);
      } else {
        $msg.removeClass('hidden').text((res && res.data && res.data.message) || 'Erreur.').css('color', '#ef4444');
      }
    }).fail(function () {
      $msg.removeClass('hidden').text('Erreur de connexion.').css('color', '#ef4444');
    }).always(function () {
      $btn.prop('disabled', false).text(btnOriginalText);
    });
  });

  // ---- Approve pending topic (moderators) ----
  $page.on('click', '.js-forum-approve-topic', function () {
    var $btn = $(this);
    var topicId = $btn.data('topic-id');

    if (!confirm('Approuver cette discussion et la rendre visible ?')) {
      return;
    }

    $btn.prop('disabled', true).text('Approbation...');

    $.post(ajaxUrl, {
      action: 'forum_approve_topic',
      nonce: nonce,
      topic_id: topicId,
    }).done(function (res) {
      if (res && res.success) {
        // Recharger le detail du topic pour mettre a jour l'affichage
        $page.find('.js-forum-topic-card[data-topic-id="' + topicId + '"]').trigger('click');
        // Aussi recharger la liste pour retirer le badge pending
        loadTopics();
      } else {
        alert((res && res.data && res.data.message) || 'Erreur lors de l\'approbation.');
        $btn.prop('disabled', false).text('Approuver');
      }
    }).fail(function () {
      alert('Erreur de connexion.');
      $btn.prop('disabled', false).text('Approuver');
    });
  });

  // ---- Edit post (topic or reply) ----
  $page.on('click', '.js-forum-edit-post', function () {
    var $btn = $(this);
    var postId = $btn.data('post-id');
    var postType = $btn.data('post-type');
    var rawContent = $btn.data('raw-content');

    // Find the content element
    var $content;
    if (postType === 'topic') {
      $content = $btn.closest('.forum-detail-content').find('.topic-content');
    } else {
      $content = $btn.closest('.py-4').find('.reply-content');
    }

    if (!$content || $content.length === 0) return;

    // Already in edit mode?
    if ($content.siblings('.js-forum-edit-area').length) return;

    // Save current HTML and hide it
    var originalHtml = $content.html();
    $content.addClass('hidden');

    // Create edit area
    var $editArea = $('<div class="js-forum-edit-area forum-edit-area">' +
      '<textarea class="js-forum-edit-textarea forum-reply-textarea" rows="4"></textarea>' +
      '<div class="forum-edit-actions">' +
      '<button type="button" class="js-forum-edit-save comment-btn">Enregistrer</button>' +
      '<button type="button" class="js-forum-edit-cancel forum-edit-cancel">Annuler</button>' +
      '</div>' +
      '</div>');

    $editArea.find('.js-forum-edit-textarea').val(rawContent);
    $content.after($editArea);
    $editArea.find('.js-forum-edit-textarea').trigger('focus');

    // Cancel
    $editArea.find('.js-forum-edit-cancel').on('click', function () {
      $editArea.remove();
      $content.removeClass('hidden');
    });

    // Save
    $editArea.find('.js-forum-edit-save').on('click', function () {
      var newContent = $editArea.find('.js-forum-edit-textarea').val().trim();
      if (!newContent) return;

      var $saveBtn = $(this);
      $saveBtn.prop('disabled', true).text('Enregistrement…');

      $.ajax({
        url: ajaxUrl,
        type: 'POST',
        dataType: 'json',
        data: {
          action: 'forum_edit_post',
          nonce: nonce,
          post_id: postId,
          content: newContent,
        },
      }).done(function (res) {
        if (res && res.success) {
          $content.html(res.data.content).removeClass('hidden');
          $btn.data('raw-content', newContent);
          $editArea.remove();
          if (postType === 'reply') {
            var $replyCard = $btn.closest('.py-4');
            var $dateSpan = $replyCard.find('.js-reply-date');
            if ($dateSpan.length && !$dateSpan.siblings('.js-reply-edited').length) {
              $dateSpan.after('<span class="js-reply-edited italic"> (modifié)</span>');
            }
          }
        } else {
          alert((res && res.data && res.data.message) || 'Erreur.');
          $saveBtn.prop('disabled', false).text('Enregistrer');
        }
      }).fail(function () {
        alert('Erreur de connexion.');
        $saveBtn.prop('disabled', false).text('Enregistrer');
      });
    });
  });

  // ---- Delete post (topic or reply) ----
  $page.on('click', '.js-forum-delete-post', function () {
    var $btn = $(this);
    var postId = $btn.data('post-id');
    var postType = $btn.data('post-type');

    var confirmMsg = postType === 'topic'
      ? 'Supprimer cette discussion et toutes ses réponses ?'
      : 'Supprimer cette réponse ?';

    if (!confirm(confirmMsg)) return;

    $.ajax({
      url: ajaxUrl,
      type: 'POST',
      dataType: 'json',
      data: {
        action: 'forum_delete_post',
        nonce: nonce,
        post_id: postId,
      },
    }).done(function (res) {
      if (res && res.success) {
        if (postType === 'topic') {
          // Go back to list and refresh
          $topicDetail.addClass('hidden').empty();
          $topicsList.show();
          $pagination.show();
          currentPage = 1;
          loadTopics();
        } else {
          // Remove the reply card
          $btn.closest('.py-4').fadeOut(300, function () {
            $(this).remove();
          });
          // Decrement reply count in both detail and list card
          var $anyReplyCount = $page.find('.js-forum-reply-count').first();
          var delTopicId = $anyReplyCount.data('topic-id');
          if (delTopicId) {
            $page.find('.js-forum-reply-count[data-topic-id="' + delTopicId + '"]').each(function () {
              var cur = Math.max(0, (parseInt($(this).text()) || 0) - 1);
              $(this).text(cur + ' réponse' + (cur > 1 ? 's' : ''));
            });
          }
        }
      } else {
        alert((res && res.data && res.data.message) || 'Erreur.');
      }
    }).fail(function () {
      alert('Erreur de connexion.');
    });
  });

  // ---- Subscribe toggle (email notifications) ----
  $page.on('click', '.js-forum-subscribe-btn', function () {
    var $btn = $(this);
    var topicId = $btn.data('topic-id');
    if (!topicId || $btn.data('subscribing')) return;

    $btn.data('subscribing', true);

    $.ajax({
      url: ajaxUrl,
      type: 'POST',
      dataType: 'json',
      data: {
        action: 'forum_toggle_subscription',
        nonce: nonce,
        topic_id: topicId,
      },
    }).done(function (res) {
      if (res && res.success) {
        var sub = res.data.subscribed;
        var $label = $btn.find('.js-forum-subscribe-label');
        $btn.find('svg').attr('fill', sub ? 'currentColor' : 'none');
        $btn.toggleClass('is-subscribed', sub);
        if (sub) {
          $label.text('Abonné par courriel');
        } else {
          $label.text('Désabonné');
          setTimeout(function () {
            $label.text("S'abonner par courriel");
          }, 2500);
        }
      }
    }).always(function () {
      $btn.data('subscribing', false);
    });
  });

  // ---- Forum-level subscribe toggle (nav) ----
  $page.on('click', '.js-forum-sub-btn', function (e) {
    e.preventDefault();
    e.stopPropagation();

    var $btn = $(this);
    var forumId = $btn.data('forum-id');
    if (!forumId || $btn.hasClass('is-busy')) return;

    $btn.addClass('is-busy');

    $.ajax({
      url: ajaxUrl,
      type: 'POST',
      dataType: 'json',
      data: {
        action: 'forum_toggle_forum_subscription',
        nonce: nonce,
        forum_id: forumId,
      },
    }).done(function (res) {
      if (res && res.success) {
        var sub = res.data.subscribed;
        // Le meme forum a une cloche dans la nav desktop et une dans le menu mobile.
        var $all = $page.find('.js-forum-sub-btn[data-forum-id="' + forumId + '"]');
        $all.toggleClass('is-subscribed', sub);
        $all.attr('aria-pressed', sub ? 'true' : 'false');
        $all.attr('title', sub
          ? 'Abonné : vous recevez les nouvelles publications par courriel'
          : "S'abonner : recevoir les nouvelles publications par courriel");
        $all.find('.js-forum-sub-label').text(sub
          ? 'Se désabonner des courriels'
          : "S'abonner aux courriels");
      } else if (res && res.data && res.data.message) {
        alert(res.data.message);
      }
    }).fail(function () {
      alert('Erreur de connexion.');
    }).always(function () {
      $btn.removeClass('is-busy');
    });
  });

  // ---- Commenter button → reveal + scroll to reply form ----
  $page.on('click', '.js-forum-scroll-to-reply', function () {
    var $replySection = $page.find('.js-forum-reply-section');
    if ($replySection.length) {
      $replySection.removeClass('hidden');
      $('html, body').animate({ scrollTop: $replySection.offset().top - 80 }, 300);
      $replySection.find('.js-forum-reply-content').focus();
    }
  });

  // ===========================================================
  // @Mention autocomplete system
  // ===========================================================
  (function () {
    var mentionsData = window.rhinnoMentions || {};
    if (!mentionsData.ajaxUrl) return;

    var $dropdown = null;
    var activeTextarea = null;
    var mentionStart = -1;
    var searchTimeout = null;

    // Crée le dropdown s'il n'existe pas
    function ensureDropdown() {
      if (!$dropdown) {
        $dropdown = $('<div class="forum-mention-dropdown hidden"></div>');
        $('body').append($dropdown);
      }
      return $dropdown;
    }

    // Détecte le contexte à partir du textarea
    function getContext($textarea) {
      // Formulaire de nouveau topic
      var $form = $textarea.closest('.js-forum-create-form');
      if ($form.length) {
        var forumId = $form.find('input[name="forum_id"]').val() || 0;
        return { context: 'new_topic', forum_id: forumId, topic_id: 0 };
      }

      // Formulaire de réponse
      var $replySection = $textarea.closest('.js-forum-reply-section');
      if ($replySection.length) {
        var topicId = $replySection.data('topic-id') || 0;
        return { context: 'reply', forum_id: 0, topic_id: topicId };
      }

      return null;
    }

    // Récupère les coordonnées du curseur dans un textarea
    function getCaretCoordinates($textarea) {
      var el = $textarea[0];
      var text = el.value.substring(0, el.selectionStart);

      var mirror = document.createElement('div');
      var style = window.getComputedStyle(el);
      var props = ['fontFamily', 'fontSize', 'fontWeight', 'lineHeight', 'letterSpacing',
        'paddingTop', 'paddingLeft', 'paddingRight', 'borderTopWidth', 'borderLeftWidth',
        'boxSizing', 'whiteSpace', 'wordWrap', 'overflowWrap'];
      props.forEach(function (p) { mirror.style[p] = style[p]; });
      mirror.style.position = 'absolute';
      mirror.style.visibility = 'hidden';
      mirror.style.whiteSpace = 'pre-wrap';
      mirror.style.width = style.width;

      mirror.textContent = text;
      var span = document.createElement('span');
      span.textContent = '|';
      mirror.appendChild(span);
      document.body.appendChild(mirror);

      var rect = $textarea[0].getBoundingClientRect();
      var coords = {
        top: rect.top + span.offsetTop - el.scrollTop + window.scrollY,
        left: rect.left + span.offsetLeft + window.scrollX
      };

      document.body.removeChild(mirror);
      return coords;
    }

    // Positionne le dropdown
    function positionDropdown($textarea) {
      var coords = getCaretCoordinates($textarea);
      ensureDropdown();
      $dropdown.css({
        top: coords.top + 24 + 'px',
        left: coords.left + 'px'
      });
    }

    // Effectue la recherche AJAX
    function searchUsers(query, ctx) {
      $.ajax({
        url: mentionsData.ajaxUrl,
        type: 'GET',
        data: {
          action: 'forum_search_mentionable_users',
          search: query,
          context: ctx.context,
          forum_id: ctx.forum_id,
          topic_id: ctx.topic_id
        },
        success: function (resp) {
          if (!resp.success || !resp.data.users.length) {
            hideDropdown();
            return;
          }
          renderDropdown(resp.data.users);
        }
      });
    }

    // Affiche la liste des utilisateurs
    function renderDropdown(users) {
      ensureDropdown();
      var html = '';
      users.forEach(function (u, i) {
        html += '<div class="forum-mention-option' + (i === 0 ? ' is-active' : '') + '" data-user-id="' + u.id + '" data-display-name="' + u.display_name.replace(/"/g, '&quot;') + '">'
          + '<span class="forum-mention-avatar">' + u.initials + '</span>'
          + '<span class="forum-mention-name">' + u.display_name + '</span>'
          + '</div>';
      });
      $dropdown.html(html).removeClass('hidden');
    }

    function hideDropdown() {
      if ($dropdown) {
        $dropdown.addClass('hidden').empty();
      }
      mentionStart = -1;
      activeTextarea = null;
    }

    // Map des mentions insérées dans chaque textarea (display → id)
    var mentionMaps = new WeakMap();

    function getMentionMap(el) {
      if (!mentionMaps.has(el)) mentionMaps.set(el, {});
      return mentionMaps.get(el);
    }

    // Convertit le texte visible en format stocké avant soumission
    window.convertMentionsForSubmit = function (el) {
      var map = getMentionMap(el);
      var val = el.value;
      Object.keys(map).forEach(function (name) {
        var escaped = name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        val = val.replace(new RegExp('@' + escaped + '(?=\\s|$|[.,;:!?)])', 'g'), '@[' + name + ']{' + map[name] + '}');
      });
      return val;
    };

    // Insère la mention dans le textarea (affiche @Name, stocke le mapping)
    function insertMention(userId, displayName) {
      if (!activeTextarea) return;
      var el = activeTextarea[0];
      var val = el.value;
      var before = val.substring(0, mentionStart);
      var after = val.substring(el.selectionStart);
      // L'utilisateur voit juste @Display Name
      var mention = '@' + displayName + ' ';

      // Stocker le mapping name → id
      getMentionMap(el)[displayName] = userId;
      el.value = before + mention + after;
      var newPos = mentionStart + mention.length;
      el.setSelectionRange(newPos, newPos);
      el.focus();
      hideDropdown();
    }

    // Écouter les saisies dans les textareas du forum
    $(document).on('input', 'textarea[name="topic_content"], .js-forum-reply-content', function () {
      var $ta = $(this);
      var el = $ta[0];
      var val = el.value;
      var pos = el.selectionStart;

      // Cherche le @ le plus récent avant le curseur
      var textBefore = val.substring(0, pos);
      var atIndex = textBefore.lastIndexOf('@');

      if (atIndex === -1) {
        hideDropdown();
        return;
      }

      // Vérifie que le @ n'est pas précédé d'un caractère alphanumérique
      if (atIndex > 0 && /\w/.test(textBefore[atIndex - 1])) {
        hideDropdown();
        return;
      }

      var query = textBefore.substring(atIndex + 1);

      // Si la query contient un espace ou est trop longue, pas de mention
      // On autorise les espaces dans le query pour les noms composés
      if (query.length > 30 || /[\n\r]/.test(query)) {
        hideDropdown();
        return;
      }

      var ctx = getContext($ta);
      if (!ctx) {
        hideDropdown();
        return;
      }

      mentionStart = atIndex;
      activeTextarea = $ta;

      positionDropdown($ta);

      clearTimeout(searchTimeout);
      searchTimeout = setTimeout(function () {
        searchUsers(query, ctx);
      }, 250);
    });

    // Clic sur une option
    $(document).on('click', '.forum-mention-option', function () {
      var userId = $(this).data('user-id');
      var displayName = $(this).data('display-name');
      insertMention(userId, displayName);
    });

    // Navigation clavier dans le dropdown
    $(document).on('keydown', 'textarea[name="topic_content"], .js-forum-reply-content', function (e) {
      if (!$dropdown || $dropdown.hasClass('hidden')) return;

      var $options = $dropdown.find('.forum-mention-option');
      var $active = $dropdown.find('.is-active');
      var idx = $options.index($active);

      if (e.key === 'ArrowDown') {
        e.preventDefault();
        var next = Math.min(idx + 1, $options.length - 1);
        $options.removeClass('is-active');
        $options.eq(next).addClass('is-active');
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        var prev = Math.max(idx - 1, 0);
        $options.removeClass('is-active');
        $options.eq(prev).addClass('is-active');
      } else if (e.key === 'Enter' || e.key === 'Tab') {
        if ($active.length) {
          e.preventDefault();
          $active.trigger('click');
        }
      } else if (e.key === 'Escape') {
        hideDropdown();
      }
    });

    // Fermer au clic extérieur
    $(document).on('click', function (e) {
      if ($dropdown && !$(e.target).closest('.forum-mention-dropdown').length) {
        hideDropdown();
      }
    });

    // Quand l'utilisateur change de catégorie/forum, réinitialiser les mentions
    // (empêche de mentionner quelqu'un d'un groupe privé A dans un topic du groupe B)
    $(document).on('change', 'input[name="forum_id"]', function () {
      var $form = $(this).closest('.js-forum-create-form');
      if (!$form.length) return;
      var $ta = $form.find('textarea[name="topic_content"]');
      if (!$ta.length) return;
      var el = $ta[0];
      var map = getMentionMap(el);
      // Retirer du texte les @mentions déjà insérées
      var val = el.value;
      Object.keys(map).forEach(function (name) {
        var escaped = name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        val = val.replace(new RegExp('@' + escaped + '(?=\\s|$|[.,;:!?)])', 'g'), '');
      });
      el.value = val.replace(/\s{2,}/g, ' ').trim();
      // Vider la map
      mentionMaps.set(el, {});
      hideDropdown();
    });
  })();

});

/**
 * Scroll Reveal - fade-in au scroll ET au chargement avec GSAP
 *
 * Porté à l'identique depuis le thème umanitheme (projet Halo).
 * Utilise IntersectionObserver pour la détection (fire automatiquement
 * pour les éléments déjà visibles au load) et GSAP pour l'animation.
 *
 * Attributs data :
 *   data-direction  - 'bottom' (défaut), 'top', 'left', 'right', 'fade'/'center' (opacité seule)
 *   data-distance   - distance de translation en px (défaut : 150)
 *   data-duration   - durée en secondes (défaut : 1)
 *   data-delay      - délai en secondes (défaut : 0)
 *   data-early      - déclenche dès l'entrée dans le viewport (sans attendre le scroll)
 *
 * @example
 *   <section class="fade-in">
 *   <section class="fade-in" data-direction="left" data-delay="0.3">
 *   <section class="fade-in" data-early>
 */

// Masque les fade-in immédiatement (avant DOMContentLoaded) pour éviter le flash
if (typeof gsap !== 'undefined' && window.innerWidth >= 959.98) {
  document.querySelectorAll('.fade-in').forEach(el => gsap.set(el, { opacity: 0 }));
}

function umani_scroll_reveal() {
  if (typeof gsap === 'undefined') return;

  // Sur mobile : aucune animation, tous les éléments apparaissent directement
  if (window.innerWidth < 959.98) {
    document.querySelectorAll('.fade-in').forEach(el => {
      gsap.set(el, { opacity: 1, x: 0, y: 0, clearProps: 'transform' });
    });
    return;
  }

  const DISTANCE = 150;

  const getFromVars = (el) => {
    const direction = (el.dataset.direction || 'bottom').trim();
    const distance = parseFloat(el.dataset.distance) || DISTANCE;
    const vars = { opacity: 0, x: 0, y: 0 };
    switch (direction) {
      case 'fade':
      case 'center': break;
      case 'top': vars.y = -distance; break;
      case 'left': vars.x = -distance; break;
      case 'right': vars.x = distance; break;
      default: vars.y = distance; break;
    }
    return vars;
  };

  const animate = (el) => {
    gsap.to(el, {
      opacity: 1, x: 0, y: 0,
      duration: parseFloat(el.dataset.duration) || 1,
      delay: parseFloat(el.dataset.delay) || 0,
      ease: 'power2.out',
      overwrite: true,
    });
  };

  const pending = new Set();

  const makeObserver = (rootMargin) => new IntersectionObserver((entries, obs) => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      animate(entry.target);
      pending.delete(entry.target);
      obs.unobserve(entry.target);
    });
  }, { threshold: 0.1, rootMargin });

  const observer = makeObserver('0px 0px -18% 0px');
  const observerEarly = makeObserver('0px 0px 200px 0px');

  document.querySelectorAll('.fade-in').forEach(el => {
    gsap.set(el, getFromVars(el));
    pending.add(el);
    ('early' in el.dataset ? observerEarly : observer).observe(el);
  });

  // Fallback : éléments en pied de page que le rootMargin empêche de déclencher
  window.addEventListener('scroll', () => {
    if (!pending.size) return;
    if (window.innerHeight + window.scrollY < document.documentElement.scrollHeight - 50) return;
    pending.forEach(el => { animate(el); observer.unobserve(el); observerEarly.unobserve(el); });
    pending.clear();
  }, { passive: true });
}

document.addEventListener('DOMContentLoaded', umani_scroll_reveal);

/* Bloc Activités/Événements - Toggle des détails au clic */
jQuery(document).ready(function ($) {
  $(document).on('click', '.evenement-toggle', function (e) {
    e.preventDefault();
    var $btn = $(this);
    var panelId = $btn.attr('aria-controls');
    if (!panelId) return;
    var $panel = $('#' + panelId);
    if (!$panel.length) return;

    var isOpen = !$panel.hasClass('hidden');
    $panel.toggleClass('hidden', isOpen);

    // Sync ARIA + chevron sur tous les toggles liés à ce panneau
    $('.evenement-toggle[aria-controls="' + panelId + '"]').each(function () {
      $(this).attr('aria-expanded', isOpen ? 'false' : 'true');
      $(this).find('.evenement-toggle-chevron').toggleClass('rotate-180', !isOpen);
    });
  });
});
